import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { ProtocolVersion } from 'entities/protocol_version'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { ProtocolVersionViewModel } from 'view_models/protocol_version_view_model'
// import { ProtocolVersionViewModel } from 'view_models/protocol_version_view_model'

export const protocolVersionColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'protocol_version_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: 'バージョン', th: true, minWidth: 120, form: form, orderAttr: 'protocol_version_number', searchType: { name: 'number', type: 'number' } },
            { name: 'Probe数', th: true, width: 100 },
        ],
    }
}

export type ProtocolVersionTableDataProps = {
    protocolVersion?: ProtocolVersion
    displaySetting: DisplaySetting
    onClickProbes?: () => void
}

export const ProtocolVersionTableData = ({ protocolVersion, displaySetting, onClickProbes }: ProtocolVersionTableDataProps): JSX.Element => {
    if (!protocolVersion) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    // const vm = new ProtocolVersionViewModel(protocolVersion)

    const createCells = useMemo(() => {
        const vm = new ProtocolVersionViewModel(protocolVersion)
        return (
            <>
                <TableCell>{protocolVersion.id}</TableCell>
                <TableCell>
                    {vm.versionView()}
                    {protocolVersion.productItem?.name && <span style={{ marginLeft: 10 }}>{protocolVersion.productItem?.name}</span>}
                </TableCell>
                <TableCell>
                    <div className="linked-text" onClick={onClickProbes}>
                        {protocolVersion.probes?.length} probes
                    </div>
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
